import { render, staticRenderFns } from "./order_types.vue?vue&type=template&id=178ae13b&scoped=true&"
import script from "./order_types.vue?vue&type=script&lang=js&"
export * from "./order_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178ae13b",
  null
  
)

export default component.exports